/**
 * Admin allowlist — single source of truth for who can access /admin/*.
 * v1: a hardcoded list. Later this can move to a Firestore `admins` collection
 * or a custom auth claim without changing the guard's call sites.
 *
 * Add your team's emails (lowercased) and/or uids here.
 */

export const ADMIN_EMAILS: string[] = [
  'ankitsingh@pythrust.com',
  'ankitdce14591@outlook.com',
  // add teammates here (lowercase)
];

export const ADMIN_UIDS: string[] = [
  'QlKRGXHofIYbpre1JRbJZykw0yY2', // Ankit (from live users collection)
  // add teammate uids here
];

/** True if the given email/uid is on the admin allowlist. */
export function isAdminUser(
  email: string | null | undefined,
  uid: string | null | undefined,
): boolean {
  const e = (email ?? '').toLowerCase().trim();
  const u = (uid ?? '').trim();
  return (!!e && ADMIN_EMAILS.includes(e)) || (!!u && ADMIN_UIDS.includes(u));
}